export default "__VITE_ASSET__1P8ChEFP__"